<template>
    <v-dialog v-model="projectProlongDialog" width="400">
        <v-card component="ProjectProlongDialog">
            <btn class="close" size="icon" color="transparent" :icon="'close'" @click="close" />

            <v-form v-model="valid" ref="form" @submit.prevent="">
                <div class="header">
                    <p>
                        This project is available until: {{ getDateWithTime(project.zobrazit_do) }} <br />
                        This will add another 30 days to the due of&nbsp;the&nbsp;project.
                    </p>
                </div>

                <div class="action">
                    <div class="buttons">
                        <btn color="transparent" :text="'Cancel'" @click="close" />
                        <btn
                            class="prolong"
                            :icon="'restore'"
                            :text="'Prolong'"
                            tpos="left"
                            :color="'secondary'"
                            :state="loading"
                            @click.prevent="prolong"
                        />
                    </div>
                    <div class="message" :class="{ done: result !== null, wrong: result === false }">
                        <i class="icon" v-if="result">done_all</i>
                        <i class="icon" v-else>warning</i>
                        <h3>Project due date was prolonged.</h3>
                    </div>
                </div>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import moment from 'moment';

export default {
    name: 'ProjectProlongDialog',

    props: {
        project: {
            type: Object,
            required: true,
        },
    },

    created() {},

    data() {
        return {
            loading: '',
            message: '',
            result: null,
            valid: true,
        };
    },

    methods: {
        ...mapActions(['prolongProject']),
        ...mapMutations(['setProjectProlongDialog']),

        getDateWithTime(date) {
            return `${moment(date).format('DD. MM. YYYY')} - ${moment(date).format('HH:mm')}`;
        },

        close() {
            this.setProjectProlongDialog(false);
        },

        async prolong() {
            this.loading = 'load';
            await this.prolongProject();
            this.loading = '';
            this.result = true;

            setTimeout(() => {
                this.setProjectProlongDialog(false);
                this.result = null;
            }, 2000);
        },
    },

    computed: {
        ...mapGetters(['getProjectProlongDialog']),

        projectProlongDialog: {
            get: function () {
                return this.getProjectProlongDialog;
            },
            set: function (val) {
                this.setProjectProlongDialog(val);
            },
        },
    },

    components: {},
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='ProjectProlongDialog'] {
    padding: 20px;

    .close {
        position: absolute;
        top: 0;
        right: 0;
        margin: 0;
    }

    form {
        display: flex;
        flex-direction: column;
    }

    .header {
        margin-bottom: 25px;

        p {
            margin: 0 30px 15px 0;
        }
    }

    .action {
        position: relative;
        overflow: hidden;
        width: 100%;
        .flex-row;
        justify-content: flex-end;

        .buttons {
            .flex-row;
        }

        .holder {
            position: relative;

            &.confirm {
                .send {
                    transform: translateY(100%);
                }

                .confirm {
                    transition-delay: 0.3s;
                    transform: translateY(0);
                }
            }

            button {
                transition: 0.3s;

                &.confirm {
                    position: absolute;
                    top: 0;
                    right: 0;
                    z-index: 4;
                    transform: translateY(100%);
                    transition-delay: 0.3s;
                }
            }
        }
    }

    .message {
        position: absolute;
        background: white;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 5;
        color: @base;
        transition: 0.3s;
        transition-delay: 0.3s;
        transform: translateY(100%);

        &.wrong {
            color: @accent;

            h3 {
                color: @accent;
            }
        }

        &.done {
            transition-delay: 0s;
            transform: translateY(0);
        }

        h3 {
            color: @base;
            margin: 0 0 0 5px;
        }
    }
}
</style>
